<ng-container *ngComponentOutlet="content"></ng-container>